import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { projectsData } from '../../data/contentData';
import { mlModels } from './managers/mlModelRegistry';
import ProjectsList from './ProjectsList';
import DeveloperProjectView from './developers/DeveloperProjectView';

const ProjectRouter = ({ persona = 'developer' }) => {
  const [selectedSlug, setSelectedSlug] = useState(null);
  const isRecruiter = persona === 'recruiter';
  const projects = isRecruiter ? mlModels : projectsData;
  const selected = selectedSlug ? projects.find(p => p.slug === selectedSlug) : null;
  const MLModelView = selected?.component;

  return (
    <AnimatePresence mode="wait">
      {!selected ? (
        <motion.div
          key="list"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <ProjectsList persona={persona} projects={projects} onSelectProject={setSelectedSlug} />
        </motion.div>
      ) : (
        <motion.div
          key={`view-${selectedSlug}`}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          transition={{ duration: 0.25 }}
        >
          <div className="max-w-4xl mx-auto px-6 pt-6">
            <button
              onClick={() => setSelectedSlug(null)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                color: '#007AFF', fontSize: 13, fontWeight: 600,
                background: 'transparent', border: 'none', cursor: 'pointer',
                padding: 0, marginBottom: 4,
              }}
            >
              <span style={{ fontSize: 16, lineHeight: 1 }}>‹</span> All projects
            </button>
          </div>
          {isRecruiter
            ? <MLModelView />
            : <DeveloperProjectView project={selected} />}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProjectRouter;
